import {
  GlobalEvents,
  SectionElement,
  defineElement,
  globalOn,
  on,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-header/common-header.ts
var CommonHeader = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isOpenLanguage = false;
    this.previousFocusedElement = null;
  }
  connectedCallback() {
    let lastScrollTop = 0;
    window.addEventListener("scroll", () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop === 0) {
        this.classList.remove("-top-[89px]");
      } else if (scrollTop > lastScrollTop) {
        this.classList.add("-top-[89px]");
      } else {
        this.classList.remove("-top-[89px]");
      }
      lastScrollTop = scrollTop;
    });
    document.addEventListener("click", (e) => {
      if (this.isOpenLanguage && this.languageOpen && this.languageModal && (!this.languageOpen.contains(e.target) && !this.languageModal.contains(e.target))) {
        this.closeLanguage();
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        if (this.isOpenLanguage) {
          this.closeLanguage();
          return;
        }
        const focusedElement = document.activeElement;
        const isInChildDrawer = focusedElement == null ? void 0 : focusedElement.closest("[data-child-link-drawer]");
        if (isInChildDrawer) {
          const childDrawer = isInChildDrawer;
          const closeButton = childDrawer.querySelector("[data-child-link-drawer-close]");
          if (closeButton) {
            closeButton.click();
            return;
          }
        }
        const isInLinkDrawer = focusedElement == null ? void 0 : focusedElement.closest("[data-link-drawer]");
        if (isInLinkDrawer) {
          const linkDrawer = isInLinkDrawer;
          const closeButton = linkDrawer.querySelector("[data-link-drawer-close]");
          if (closeButton) {
            closeButton.click();
            return;
          }
        }
        if (this.drawer.isOpen) {
          this.close();
          return;
        }
        const isInDropdown = focusedElement == null ? void 0 : focusedElement.closest("[data-dropdown-content]");
        if (!isInDropdown) {
          this.closeAllDropdowns();
        }
      }
    });
  }
  handleOpenLinkDrawer(elm) {
    const handle = elm.dataset.linkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    const linkDrawer = this.linkDrawers.find((d) => d.key === handle);
    if (linkDrawer) {
      this.previousFocusedElement = elm;
      linkDrawer.open();
      setTimeout(() => {
        const firstFocusable = linkDrawer.querySelector("a, button");
        firstFocusable == null ? void 0 : firstFocusable.focus();
      }, 100);
    }
  }
  handleOpenChildLinkDrawer(elm) {
    const handle = elm.dataset.childLinkButton;
    if (handle == null || typeof handle === "undefined")
      return;
    const childDrawer = this.childLinkDrawers.find((d) => d.key === handle);
    if (childDrawer) {
      this.previousFocusedElement = elm;
      childDrawer.open();
      setTimeout(() => {
        const firstFocusable = childDrawer.querySelector("a, button");
        firstFocusable == null ? void 0 : firstFocusable.focus();
      }, 100);
    }
  }
  handleCloseLinkDrawer(elm) {
    const handle = elm.dataset.linkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    const linkDrawer = this.linkDrawers.find((d) => d.key === handle);
    if (linkDrawer) {
      linkDrawer.close();
      setTimeout(() => {
        if (this.previousFocusedElement) {
          this.previousFocusedElement.focus();
          this.previousFocusedElement = null;
        }
      }, 100);
    }
  }
  handleCloseChildLinkDrawer(elm) {
    const handle = elm.dataset.childLinkDrawerClose;
    if (handle == null || typeof handle === "undefined")
      return;
    const childDrawer = this.childLinkDrawers.find((d) => d.key === handle);
    if (childDrawer) {
      childDrawer.close();
      setTimeout(() => {
        if (this.previousFocusedElement) {
          this.previousFocusedElement.focus();
          this.previousFocusedElement = null;
        }
      }, 100);
    }
  }
  handleDropdownTriggerClick(element, event) {
    event.preventDefault();
    this.toggleDropdown(element);
  }
  handleDropdownTriggerKeyDown(element, event) {
    switch (event.key) {
      case "Enter":
      case " ":
        event.preventDefault();
        this.toggleDropdown(element);
        break;
      case "ArrowDown":
        event.preventDefault();
        this.openDropdownForCurrentItem(element);
        break;
      case "ArrowUp":
        event.preventDefault();
        const parentGroup = element.closest(".group");
        const mainMenuItem = parentGroup == null ? void 0 : parentGroup.querySelector("[data-main-menu-item]");
        if (mainMenuItem) {
          mainMenuItem.focus();
        }
        break;
      case "ArrowLeft":
      case "ArrowRight":
        event.preventDefault();
        const parentGroupNav = element.closest(".group");
        const mainMenuItemNav = parentGroupNav == null ? void 0 : parentGroupNav.querySelector("[data-main-menu-item]");
        if (mainMenuItemNav) {
          mainMenuItemNav.focus();
          const navEvent = new KeyboardEvent("keydown", {
            key: event.key,
            bubbles: true,
            cancelable: true
          });
          mainMenuItemNav.dispatchEvent(navEvent);
        }
        break;
      case "Escape":
        event.preventDefault();
        this.closeAllDropdowns();
        break;
    }
  }
  showLanguageModal() {
    return __async(this, null, function* () {
      if (this.isOpenLanguage) {
        void this.closeLanguage();
      } else {
        yield this.openLanguage();
      }
    });
  }
  openLanguage() {
    return __async(this, null, function* () {
      if (this.languageModal) {
        this.previousFocusedElement = document.activeElement;
        this.languageModal.open();
        this.isOpenLanguage = true;
        this.setupLanguageFocusTrap();
      }
    });
  }
  closeLanguage() {
    return __async(this, null, function* () {
      if (this.languageModal) {
        this.languageModal.close();
        this.isOpenLanguage = false;
        if (this.previousFocusedElement) {
          this.previousFocusedElement.focus();
          this.previousFocusedElement = null;
        }
      }
    });
  }
  showModal() {
    var _a;
    (_a = this.searchModal) == null ? void 0 : _a.open();
  }
  handleOpenCart() {
    GlobalEvents.emit("cart:open");
  }
  handleOpenMenu() {
    GlobalEvents.emit("menu:open");
  }
  open() {
    return __async(this, null, function* () {
      this.previousFocusedElement = document.activeElement;
      this.drawer.open();
      setTimeout(() => {
        if (this.mobileMenuItems.length > 0) {
          this.mobileMenuItems[0].focus();
        }
      }, 100);
    });
  }
  close() {
    return __async(this, null, function* () {
      this.drawer.close();
      if (this.previousFocusedElement) {
        this.previousFocusedElement.focus();
        this.previousFocusedElement = null;
      }
    });
  }
  handleMainMenuKeyDown(element, event) {
    const items = Array.from(this.mainMenuItems);
    const currentIndex = items.indexOf(element);
    switch (event.key) {
      case "ArrowRight":
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % items.length;
        items[nextIndex].focus();
        this.closeAllDropdowns();
        break;
      case "ArrowLeft":
        event.preventDefault();
        const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
        items[prevIndex].focus();
        this.closeAllDropdowns();
        break;
      case "ArrowDown":
        event.preventDefault();
        const parentGroup = element.closest(".group");
        const dropdownTrigger = parentGroup == null ? void 0 : parentGroup.querySelector("[data-dropdown-trigger]");
        if (dropdownTrigger) {
          dropdownTrigger.focus();
        } else {
          element.focus();
        }
        break;
      case "Escape":
        event.preventDefault();
        this.closeAllDropdowns();
        break;
    }
  }
  handleMobileMenuKeyDown(element, event) {
    if (!this.drawer.isOpen)
      return;
    const items = Array.from(this.mobileMenuItems);
    const currentIndex = items.indexOf(element);
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % items.length;
        items[nextIndex].focus();
        break;
      case "ArrowUp":
        event.preventDefault();
        const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
        items[prevIndex].focus();
        break;
      case "Enter":
      case " ":
        event.preventDefault();
        element.click();
        break;
      case "Escape":
        event.preventDefault();
        event.stopPropagation();
        this.close();
        break;
    }
  }
  handleLinkDrawerKeyDown(element, event) {
    const drawer = element.closest("[data-link-drawer]");
    if (!drawer)
      return;
    const items = Array.from(drawer.querySelectorAll("a, button"));
    const currentIndex = items.indexOf(element);
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % items.length;
        items[nextIndex].focus();
        break;
      case "ArrowUp":
        event.preventDefault();
        const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
        items[prevIndex].focus();
        break;
      case "Enter":
      case " ":
        event.preventDefault();
        element.click();
        break;
      case "Escape":
        event.preventDefault();
        event.stopPropagation();
        const drawerClose = drawer.querySelector("[data-link-drawer-close]");
        if (drawerClose) {
          drawerClose.click();
        }
        break;
      case "Home":
        event.preventDefault();
        items[0].focus();
        break;
      case "End":
        event.preventDefault();
        items[items.length - 1].focus();
        break;
    }
  }
  handleChildLinkDrawerKeyDown(element, event) {
    const drawer = element.closest("[data-child-link-drawer]");
    if (!drawer)
      return;
    const items = Array.from(drawer.querySelectorAll("a, button"));
    const currentIndex = items.indexOf(element);
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % items.length;
        items[nextIndex].focus();
        break;
      case "ArrowUp":
        event.preventDefault();
        const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
        items[prevIndex].focus();
        break;
      case "Enter":
      case " ":
        event.preventDefault();
        element.click();
        break;
      case "Escape":
        event.preventDefault();
        event.stopPropagation();
        const drawerClose = drawer.querySelector("[data-child-link-drawer-close]");
        if (drawerClose) {
          drawerClose.click();
        }
        break;
      case "Home":
        event.preventDefault();
        items[0].focus();
        break;
      case "End":
        event.preventDefault();
        items[items.length - 1].focus();
        break;
    }
  }
  handleLocalizationKeyDown(element, event) {
    switch (event.key) {
      case "Enter":
      case " ":
        event.preventDefault();
        this.showLanguageModal();
        break;
    }
  }
  handleSearchKeyDown(element, event) {
    switch (event.key) {
      case "Enter":
      case " ":
        event.preventDefault();
        this.showModal();
        break;
    }
  }
  handleCartKeyDown(element, event) {
    switch (event.key) {
      case "Enter":
      case " ":
        event.preventDefault();
        this.handleOpenCart();
        break;
    }
  }
  handleMenuKeyDown(element, event) {
    switch (event.key) {
      case "Enter":
      case " ":
        event.preventDefault();
        this.handleOpenMenu();
        break;
    }
  }
  // Accessibility helper methods
  openDropdownForCurrentItem(element) {
    const parentGroup = element.closest(".group");
    const dropdownTrigger = parentGroup == null ? void 0 : parentGroup.querySelector("[data-dropdown-trigger]");
    const dropdown = parentGroup == null ? void 0 : parentGroup.querySelector("[data-dropdown-content]");
    if (dropdown && dropdownTrigger) {
      dropdown.classList.add("block", "!block");
      dropdown.classList.remove("hidden");
      dropdownTrigger.setAttribute("aria-expanded", "true");
      this.focusFirstDropdownItem(dropdown);
    }
  }
  toggleDropdown(element) {
    const parentGroup = element.closest(".group");
    const dropdown = parentGroup == null ? void 0 : parentGroup.querySelector("[data-dropdown-content]");
    if (dropdown) {
      const isOpen = dropdown.classList.contains("block") || !dropdown.classList.contains("hidden");
      if (isOpen) {
        this.closeDropdown(element);
      } else {
        this.openDropdownForCurrentItem(element);
      }
    }
  }
  closeDropdown(element) {
    const parentGroup = element.closest(".group");
    const dropdown = parentGroup == null ? void 0 : parentGroup.querySelector("[data-dropdown-content]");
    if (dropdown) {
      dropdown.classList.add("hidden");
      dropdown.classList.remove("block", "!block");
      element.setAttribute("aria-expanded", "false");
      element.focus();
    }
  }
  closeAllDropdowns() {
    this.dropdownTriggers.forEach((trigger) => {
      const parentGroup = trigger.closest(".group");
      const dropdown = parentGroup == null ? void 0 : parentGroup.querySelector("[data-dropdown-content]");
      if (dropdown) {
        dropdown.classList.add("hidden");
        dropdown.classList.remove("block", "!block");
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  }
  focusFirstDropdownItem(dropdown) {
    const firstFocusable = dropdown.querySelector('a[role="menuitem"], button[role="menuitem"], [tabindex="0"]');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }
  setupLanguageFocusTrap() {
    if (!this.languageModal)
      return;
    const focusableElements = this.languageModal.querySelectorAll(
      'a, button, [tabindex="0"], input, select, textarea'
    );
    if (focusableElements.length === 0)
      return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    firstElement.focus();
    const trapFocus = (event) => {
      const keyboardEvent = event;
      if (keyboardEvent.key === "Tab") {
        if (keyboardEvent.shiftKey) {
          if (document.activeElement === firstElement) {
            keyboardEvent.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            keyboardEvent.preventDefault();
            firstElement.focus();
          }
        }
      }
    };
    this.languageModal.addEventListener("keydown", trapFocus);
  }
};
__decorateClass([
  query("[data-menu-drawer]")
], CommonHeader.prototype, "drawer", 2);
__decorateClass([
  query("[search-modal]")
], CommonHeader.prototype, "searchModal", 2);
__decorateClass([
  query("[language-modal]")
], CommonHeader.prototype, "languageModal", 2);
__decorateClass([
  query("[data-localization-open]")
], CommonHeader.prototype, "languageOpen", 2);
__decorateClass([
  queryAll("[data-link-drawer]")
], CommonHeader.prototype, "linkDrawers", 2);
__decorateClass([
  queryAll("[data-child-link-drawer]")
], CommonHeader.prototype, "childLinkDrawers", 2);
__decorateClass([
  queryAll("[data-main-menu-item]")
], CommonHeader.prototype, "mainMenuItems", 2);
__decorateClass([
  queryAll("[data-mobile-menu-item]")
], CommonHeader.prototype, "mobileMenuItems", 2);
__decorateClass([
  queryAll("[data-dropdown-trigger]")
], CommonHeader.prototype, "dropdownTriggers", 2);
__decorateClass([
  onClick("[data-link-button]")
], CommonHeader.prototype, "handleOpenLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-button]")
], CommonHeader.prototype, "handleOpenChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-link-drawer-close]")
], CommonHeader.prototype, "handleCloseLinkDrawer", 1);
__decorateClass([
  onClick("[data-child-link-drawer-close]")
], CommonHeader.prototype, "handleCloseChildLinkDrawer", 1);
__decorateClass([
  onClick("[data-dropdown-trigger]")
], CommonHeader.prototype, "handleDropdownTriggerClick", 1);
__decorateClass([
  on("keydown", "[data-dropdown-trigger]")
], CommonHeader.prototype, "handleDropdownTriggerKeyDown", 1);
__decorateClass([
  onClick("[data-localization-open]")
], CommonHeader.prototype, "showLanguageModal", 1);
__decorateClass([
  onClick("[data-localization-close]")
], CommonHeader.prototype, "closeLanguage", 1);
__decorateClass([
  onClick("[data-modal-search]")
], CommonHeader.prototype, "showModal", 1);
__decorateClass([
  onClick("[data-open-cart]")
], CommonHeader.prototype, "handleOpenCart", 1);
__decorateClass([
  onClick("[data-open-menu]")
], CommonHeader.prototype, "handleOpenMenu", 1);
__decorateClass([
  query("[data-additional-text]")
], CommonHeader.prototype, "addText", 2);
__decorateClass([
  query("[data-menu-row]")
], CommonHeader.prototype, "menuRow", 2);
__decorateClass([
  query("[data-menu2-row]")
], CommonHeader.prototype, "menuRow2", 2);
__decorateClass([
  query("[data-row-container]")
], CommonHeader.prototype, "rowContainer", 2);
__decorateClass([
  query("[data-shop-logo]")
], CommonHeader.prototype, "shopLogo", 2);
__decorateClass([
  query("[data-mobile-text]")
], CommonHeader.prototype, "addTextMobile", 2);
__decorateClass([
  query("[data-menu-row-mega]")
], CommonHeader.prototype, "menuRowMega", 2);
__decorateClass([
  globalOn("menu:open")
], CommonHeader.prototype, "open", 1);
__decorateClass([
  globalOn("menu:close"),
  onClick("[data-menu-close]")
], CommonHeader.prototype, "close", 1);
__decorateClass([
  on("keydown", "[data-main-menu-item]")
], CommonHeader.prototype, "handleMainMenuKeyDown", 1);
__decorateClass([
  on("keydown", "[data-mobile-menu-item]")
], CommonHeader.prototype, "handleMobileMenuKeyDown", 1);
__decorateClass([
  on("keydown", "[data-link-drawer] a, [data-link-drawer] button")
], CommonHeader.prototype, "handleLinkDrawerKeyDown", 1);
__decorateClass([
  on("keydown", "[data-child-link-drawer] a, [data-child-link-drawer] button")
], CommonHeader.prototype, "handleChildLinkDrawerKeyDown", 1);
__decorateClass([
  on("keydown", "[data-localization-open]")
], CommonHeader.prototype, "handleLocalizationKeyDown", 1);
__decorateClass([
  on("keydown", "[data-modal-search]")
], CommonHeader.prototype, "handleSearchKeyDown", 1);
__decorateClass([
  on("keydown", "[data-open-cart]")
], CommonHeader.prototype, "handleCartKeyDown", 1);
__decorateClass([
  on("keydown", "[data-open-menu]")
], CommonHeader.prototype, "handleMenuKeyDown", 1);
CommonHeader = __decorateClass([
  defineElement("common-header")
], CommonHeader);
export {
  CommonHeader
};
